import { colors } from '@dexma/ui-components';
import styled from 'styled-components';

export const StyledColorPicker = styled.div<{ $error: boolean; $showInput?: boolean }>`
    padding: ${(props) => (props.$showInput ? '20px 30px 0px 30px' : '3rem 0 0 2.25rem')};
    .widget-type-block span {
        font-weight: 700;
        color: ${colors.gray700};
    }

    .form-control-input,
    .form-control-textarea {
        border-color: ${(props) => props.$error && colors.red};
    }

    .error {
        color: ${colors.red};
        text-align: left;
    }
`;
